import React, { PureComponent } from 'react';
import {
  Accordion,
  Button,
  Grid,
  Icon,
  Input,
  Modal,
  Popup
} from 'semantic-ui-react';
import shortid from 'short-id';

import getFullNameOrUserName from '../../../utils/user';
import NoteDetail from './NoteDetail';
import './NotesQC.css';

class NotesQC extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentNote: '',
      qC: {},
      notes: [],
      showHistory: false,
      hasQC: false,
      showClearModal: false,
      approveOpen: false,
      qcNote: '',
      urlTootip: props.url
    };
  }

  onCloseClearModal = () => {
    this.setState({ showClearModal: false });
  };

  handleSave = () => {
    const fullname = getFullNameOrUserName(this.props.user);
    const { notes } = this.state;
    const newNote = {
      noteText: this.state.currentNote,
      fullname,
      username: this.props.user.email,
      note_type: 0,
      createdDate: new Date()
    };
    notes.splice(0, 0, newNote);
    this.setState({
      notes,
      currentNote: ''
    });
  };
  approveNextQC = () => {
    const newQC = this.state.qC;
    const fullname = getFullNameOrUserName(this.props.user);
    if (newQC.qc1) {
      newQC.qc2 = true;
      newQC.qc2Username = true;
      newQC.qc2Fullname = fullname;
    }
    newQC.qc1 = true;
    newQC.qc1Username = true;
    newQC.qc1Fullname = fullname;
    this.setState({ hasQC: true, qC: newQC, approveOpen: false });
    this.props.onQCUpdate(newQC);
  };
  handleClear = () => {
    this.setState({ hasQC: false, qC: {} });
    this.props.onQCUpdate({});
    this.onCloseClearModal();
  };
  handleCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(this.props.url);
      this.setState({ urlTootip: 'Copied to clipboard' });
    } catch (e) {
      console.log(e.response);
    }
  };
  isClearDisable = () => {
    const { qC } = this.state;
    if (this.state.hasQC) {
      return !qC.qc1 && !qC.qc2;
    }
    return true;
  };
  renderNotes = (adNotes) => {
    if (adNotes && adNotes.length > 0) {
      return (
        <Accordion>
          <Accordion.Title
            active={this.state.showHistory}
            onClick={() => {
              this.setState({ showHistory: !this.state.showHistory });
            }}
          >
            <Icon name="dropdown" /> Notes History
          </Accordion.Title>
          <Accordion.Content active={this.state.showHistory}>
            <Grid className="notes-history" divided="vertically">
              {adNotes.map((adNote) => (
                <NoteDetail
                  key={shortid.generate()}
                  user={this.props.user}
                  adNote={adNote}
                  adPreview={this.props.adPreview}
                  updateParent={this.updateParent}
                />
              ))}
            </Grid>
          </Accordion.Content>
        </Accordion>
      );
    }
    return null;
  };
  render() {
    const adNotes = this.state.notes;
    return (
      <div className="demo-notes-container">
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Popup
                trigger={
                  <div>
                    Post URL{` `}
                    <Icon
                      name="copy"
                      color="grey"
                      link
                      onClick={() => this.handleCopyToClipboard()}
                    />
                  </div>
                }
                content={this.state.urlTootip}
                on="hover"
                onClose={() => this.setState({ urlTootip: this.props.url })}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={8}>
              <Input
                fluid
                placeholder="Add Note"
                value={this.state.currentNote}
                onChange={(event, data) => {
                  this.setState({ currentNote: data.value });
                }}
                action={
                  <Button
                    onClick={() => {
                      this.handleSave();
                    }}
                    color="blue"
                  >
                    Save
                  </Button>
                }
              />
              {this.renderNotes(adNotes)}
            </Grid.Column>
            <Grid.Column width={8}>
              <Popup
                flowing
                on="click"
                open={this.state.approveOpen}
                trigger={
                  <Button
                    onClick={() => {
                      this.setState({
                        approveOpen: !this.state.approveOpen,
                        holdOpen: false
                      });
                    }}
                    color="green"
                  >
                    Approve
                  </Button>
                }
              >
                <Grid>
                  <Grid.Row>
                    <Grid.Column>
                      <Input
                        fluid
                        placeholder="Add Note to the Approve QC"
                        value={this.state.qcNote}
                        onChange={(event, data) => {
                          this.setState({ qcNote: data.value });
                        }}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <Button
                        onClick={() => {
                          this.approveNextQC();
                        }}
                        color="blue"
                      >
                        Confirm Approve
                      </Button>
                      <Button
                        onClick={() => {
                          this.setState({ approveOpen: false, qcNote: '' });
                        }}
                        color="red"
                      >
                        Cancel Approve
                      </Button>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Popup>
              <Button
                disabled={this.isClearDisable()}
                onClick={() => {
                  this.setState({
                    showClearModal: true,
                    holdOpen: false,
                    approveOpen: false,
                    qcNote: ''
                  });
                }}
                color="red"
              >
                Clear All
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Modal
          open={this.state.showClearModal}
          onClose={this.onCloseClearModal}
        >
          <Modal.Header>Warning Clear All QC</Modal.Header>
          <Modal.Content>
            Are you sure you want to clear QC values for this ad?
            <Input
              fluid
              placeholder="Add Note to Clear QC"
              value={this.state.qcNote}
              onChange={(event, data) => {
                this.setState({ qcNote: data.value });
              }}
            />
          </Modal.Content>
          <Modal.Actions>
            <Button
              onClick={() => {
                this.handleClear();
              }}
              color="red"
            >
              Yes
            </Button>
            <Button onClick={this.onCloseClearModal}>No</Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}
export default NotesQC;



// WEBPACK FOOTER //
// ./src/screens/Compliance/components/NotesQC.js